/**
 * Validates a US phone number with area code
 * Exaclty 10 digits, can't start with 0 or 1
 */
export function phoneValidator(phone: string): boolean {
  return /^[2-9][0-9]{9}$/.test(phone);
}
